import {Avatar, Layout, Text} from '@di-nxt/components';
import React, {useCallback, useMemo, useState} from 'react';
import {MemberDropdown} from '../../../../components/memberdropdown';
import {Absence, useTeamMembers} from '../../../../services';

type Props = {
  teamId: number;
  absence: Absence | undefined;
  onMemberChanged: (memberId: number | undefined) => void;
};

export const MemberEditor: React.FC<Props> = ({
  teamId,
  absence,
  onMemberChanged,
}) => {
  // Data
  const members = useTeamMembers(teamId);
  const member = useMemo(
    () =>
      absence
        ? members.find(m => m.membershipId === absence.membershipId)
        : undefined,
    [absence, members],
  );
  // State
  const [memberId, setMemberId] = useState<number | undefined>(
    absence?.membershipId,
  );
  const updateMemberId = useCallback(
    (nextMemberId: number | undefined) => {
      setMemberId(nextMemberId);
      onMemberChanged(nextMemberId);
    },
    [onMemberChanged],
  );
  return absence ? (
    <Layout flex>
      <Avatar name={member?.display} uri={member?.avatarUrl} />
      <Layout align="center" paddingHorizontal="16" flex>
        <Text variant="inline_16_default">{member?.display}</Text>
      </Layout>
    </Layout>
  ) : (
    <MemberDropdown
      teamId={teamId}
      selectedMemberId={memberId}
      onMemberSelected={updateMemberId}
    />
  );
};
